'use client';

import { Button } from '@curology/ui-components-web/react/Button';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React, { useState } from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';
import { type InformationSlimStep } from '@/services/funnelService/models/informationSlimStep';

export const InformationSlim = ({ step }: { step: InformationSlimStep }) => {
  const { onNext } = useNavigation();
  const [isNavigating, setIsNavigating] = useState(false);

  const onBtnNextClick = () => {
    if (isNavigating) {
      return;
    }
    setIsNavigating(true);
    onNext();
  };

  return (
    <section className="cur-text-primary">
      <div className="cur-px-4 cur-py-8 cur-mx-auto">
        <div className="cur-max-w-sm cur-my-0 cur-mx-auto cur-relative cur-px-2">
          {step.icon && (
            <div className="cur-text-[52px] cur-text-center">{step.icon}</div>
          )}
          <Typography
            className="cur-leading-9 cur-whitespace-pre-line lg:cur-text-d2m lg:cur-leading-d2m lg:cur-tracking-d2m"
            size={step.description ? 'h1' : 'd2'}
          >
            <div dangerouslySetInnerHTML={{ __html: step.title }}></div>
          </Typography>
          {step.description && (
            <Typography size="body" className="cur-mt-6 cur-leading-relaxed">
              <div dangerouslySetInnerHTML={{ __html: step.description }}></div>
            </Typography>
          )}
          {(step.image || step.contentfulImageUrl) && (
            <div className="cur-mx-auto">
              <Image
                priority
                // @ts-expect-error - TODO: broken by strictNullChecks
                src={step.image ? step.image.src : step.contentfulImageUrl}
                alt={step.image ? step.image.alt : 'Hero image'}
                quality={100}
                width={384}
                height={284}
                className="cur-mx-auto"
              />
            </div>
          )}
          <div className="cur-flex cur-flex-col cur-gap-y-2">
            <Button
              className="cur-mt-6 cur-w-full"
              onClick={onBtnNextClick}
              loading={isNavigating}
            >
              {step.nextBtnText}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
